import firebase from "firebase/app";
import "firebase/auth";
import Vue from "vue";
import Router from "vue-router";
import LoginMain from "../components/LoginMain";
import Register from "../components/Register";
import Dashboard from "../components/Dashboard";
import Upload from "../components/Upload";
import Scan from "../components/Scan";
import History from "../components/History";
import store from "../store";
import {getAuth} from "firebase/auth";
import ClientsTable from "@/components/ClientsTable";
import AddUrl from "@/pages/AddUrl";
import UploadedDocuments from "@/pages/UploadedDocuments";
import ClientHistory from "@/pages/ClientHistory";
import EndUsers from "@/pages/EndUsers";
import EndUserBase from "@/pages/EndUserBase";

Vue.use(Router);

const router = new Router({
    mode: "history",
    // base: process.env.BASE_URL,
    routes: [
        {
            path: "*",
            redirect: "/upload",
        },
        {
            path: "/",
            name: "index",
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/login",
            name: "login",
            component: LoginMain,
        },
        {
            path: "/register",
            name: "Register",
            component: Register,
            meta: {
                requiresAdmin: true,
                requiresAuth: true,
            },
        },
        {
            path: "/dashboard",
            name: "Dashboard",
            component: Dashboard,
        },
        // {
        //     path: '/',
        //     name: 'Login',
        //     component: App
        // },
        // {
        //     path: '/',
        //     name: 'index',
        //     component: App
        // },
        {
            path: "/history",
            name: "history",
            component: History,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/client-history",
            name: "client-history",
            component: ClientHistory,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/:id/documents',
            name: 'history-documents',
            component: UploadedDocuments,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/all-url',
            name: 'all-urls',
            component: AddUrl,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/clients",
            name: "clients",
            component: ClientsTable,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/upload",
            name: "upload",
            component: Upload,
            meta: {
                requiresAuth: true,
                reload: true,
            },
        },
        {
            path: "/scan",
            name: "scan",
            component: Scan,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/:id/end-users",
            name: "end-users-by-id",
            component: EndUsers,
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: "/end-users",
            name: "end-users",
            component: EndUserBase,
            meta: {
                requiresAuth: true,
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);

    // console.log({ to });

    if (requiresAuth) {
        if (requiresAdmin) {
            if (store.state.user.isAdmin) next();
            else next("upload");
        } else {
            if (currentUser) {
                if (to.name === "index") {
                    // http://localhost:8080/?fileId=243
                    // console.log("im here");
                    if (to.query.fileId) next({name: "scan", query: {fileId: to.query.fileId, chain: to.query.chain}});
                    else next("upload");
                } else {
                    next();
                }
            } else {
                next("login");
            }
        }
    } else {
        if (currentUser) next("upload");
        else next();
    }

    // if (requiresAdmin && !store.state.user.isAdmin) next("upload");
    // else if (requiresAuth && !currentUser) next("login");
    // else if (!requiresAuth && currentUser) next("upload");
    // else {
    //   next();
    // }

    // console.log("look");
    // console.log(store.state.windowWidth);
    // console.log(store.state.sidebarHidden);

    if (store.state.windowWidth < 800 && !store.state.sidebarHidden) {
        store.commit("TOGGLE_SIDEBAR_HIDDEN");
    }
});

export default router;
